import { Injectable } from '@angular/core';
import type { CompanyFindInterface } from '@zaoblako/shared/modules/client/dtos/company/find/company-find.dto';
import type { AccountCashesBalancesReportFindInterface } from '@zaoblako/shared/modules/dashboard/dtos/acb/account-cashes-balances-report-find.dto';
import type { ReportListItemFindInterface } from '@zaoblako/shared/modules/dashboard/dtos/acb/report-list-item-find.dto';
import { CreditDebitReportItemInterface } from '@zaoblako/shared/modules/debts/dtos/credit-debit-report/credit-debit-report-item.dto';
import { KeysOfType } from '@zaoblako/web/core/types/keys-of.type';
import { AccountsCompanyDebt } from '../../../modules/dashboard/models/dashboard-accounts-debt.interface';

@Injectable({ providedIn: 'root' })
export class DashboardUtilsService {
  public filterBalancesByFieldLength(
    balances: AccountCashesBalancesReportFindInterface,
    field: KeysOfType<ReportListItemFindInterface, Array<any>>
  ): AccountCashesBalancesReportFindInterface {
    if (balances) {
      return {
        ...balances,
        items: balances.items.filter((companyData) => companyData[field].length || !companyData.succeed)
      };
    } else {
      return balances;
    }
  }

  public getAccountsDebtWidgetData(items: CreditDebitReportItemInterface[]): AccountsCompanyDebt[] {
    const companies: CompanyFindInterface[] = [];
    const companiesMap = <Record<number, boolean>>{};

    items.forEach((item) => {
      const companyId = item.company ? item.company.id : NaN;
      if (companiesMap[companyId]) {
        return;
      }

      companies.push(
        Number.isNaN(companyId) ? ({ id: NaN, name: 'Компания неизвестна' } as CompanyFindInterface) : item.company
      );
      companiesMap[companyId] = true;
    });

    return companies.map((company) => ({
      company,
      amount: Number.isNaN(company.id)
        ? items.reduce((sum, item) => sum + (item.company ? 0 : item.amount), 0)
        : items.reduce((sum, item) => sum + (item.company?.id === company.id ? item.amount : 0), 0)
    }));
  }
}
